import { render, staticRenderFns } from "./MhRadio.vue?vue&type=template&id=635e9489&scoped=true"
import script from "./MhRadio.vue?vue&type=script&lang=js"
export * from "./MhRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e9489",
  null
  
)

export default component.exports